import { Component, inject } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { AuthShared } from 'src/app/auth/auth-shared.abstract';
import { OperationInfoService } from 'src/app/common/long-operations/operation-info.service';
import { EmailForm } from '../auth-form.inteface';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent extends AuthShared<EmailForm> {
  private operationInfoService = inject(OperationInfoService);

  public submitReset(): void {
    if (this.form.invalid) {
      this.validateAllFields();
      return;
    }

    this.operationInfoService.setupOperation(
      {
        spinner: 'button',
        button: { id: 'reset-password-form-reset-btn' },
        successfulMessage: 'RESET_PASSWORD_VERIFICATION_DIALOGUE_BODY',
      },
      () => {
        this.authService.resetPassword(this.form.value.email.trim());
      },
    );
  }

  protected initializeForm(): void {
    this.form = new FormGroup({
      email: new FormControl('', this.validationService.getValidators('email')),
    });

    this.validationService.setMaxInputLength(this.form, 'email');
  }
}
